module.exports = __webpack_public_path__ + "img/vsHandCream3.eefb480f.jpg";